import { defineMessages } from 'react-intl';
export default defineMessages({
    copyText: {
        id: 'shared.copy-box.button.copyText',
        defaultMessage: 'Copy text',
    },
});
